import { campaignAPI } from "@api";
import { ArrowLeftColor, ComponentMenuBar } from "@components";
import { PATH_MY_STATE, PATH_UPLOAD_ACTIVITY, enumLanguage } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { CrownCustom } from "../icon/CrownCustom";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentPersonalFitness = (props: IProps) => {
    //page props
    const { socials } = props;
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [campaign, setCampaign] = useState<any>();
    const [myData, setMyData] = useState<any>();
    const [userList, setUserList] = useState<any>([]);
    const [isLoading, setIsloading] = useState(true);
    const i18nextLng = window.localStorage.i18nextLng;

    const onSlideChange2 = (e: any) => {
        setCurrentIndex(e.activeIndex as number);
    };

    // const getapitest = await campaignAPI.getCampaign(id);

    const getCampaign = async () => {
        try {
            const getMydata = await campaignAPI.getMyCampaignData(id);
            const get = await campaignAPI.getCampaign(id);
            const getUser = await campaignAPI.getUserCampaignData(id, "");
            if (getUser.data) {
                setUserList(getUser.data);
            }
            if (getMydata.data) {
                setMyData(getMydata.data);
            }
            if (get.data) {
                setCampaign(get.data);
            }
            setIsloading(false);
        } catch (err: any) {
            // err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
            console.log(err);
            setIsloading(false);
        }
    };

    const setColor = themes?.themeColor;

    const hexToRgba = (setColor: any) => {
        setColor = setColor.replace("#", "");

        let r = parseInt(setColor.substring(0, 2), 16);
        let g = parseInt(setColor.substring(2, 4), 16);
        let b = parseInt(setColor.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, 0.14)`;
    };

    const rgbaColor = hexToRgba(setColor || "#FFFFFF");

    useEffect(() => {
        setIsloading(true);
        getCampaign();
    }, []);

    const findleaderboard = campaign?.mechanics?.find(
        (target: any) => target.type === "LEADERBOARD"
    );
    const getMyData = userList.find((user: any) => user.userId === myData.userId);

    const ladderboardInfo = [[...userList]];

    return (
        <>
            <RenderMeta title={t("meta.personal_page")} />
            <StyledPersonalFitness
                themeColor={themes?.themeColor!}
                color={rgbaColor}
                campaignColor={campaign?.campaignColor}
            >
                <Skeleton active loading={isLoading} title paragraph={false} />
                <div className="layout-img-skeleton">
                    <Skeleton loading={isLoading} active title={true} paragraph={false}>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor!}
                                onClick={() => history.goBack()}
                            />
                            {/* <span>{t("page.back")}</span> */}
                        </div>

                        <div className="logo-survey">
                            {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                                ? campaign?.name?.EN
                                : campaign?.name?.TH}
                        </div>

                        <div className="main-slide-leaderboard">
                            <Swiper
                                slidesPerView={ladderboardInfo.length > 1 ? 1.1 : 1}
                                spaceBetween={20}
                                pagination={true}
                            >
                                {ladderboardInfo.length > 0 &&
                                    ladderboardInfo.map((users: any) => {
                                        console.log("users", users);
                                        return (
                                            <SwiperSlide>
                                                <div className="layout-leaderboard">
                                                    <div className="title-leaderboard">
                                                        {t("page.campaign.leaderboard")}
                                                    </div>
                                                    <div className="wrapper-group-leader">
                                                        {users.map((user: any, index: number) => {
                                                            console.log("usermap", user);
                                                            return (
                                                                <>
                                                                    {findleaderboard.ranking
                                                                        .length >= 2 && (
                                                                        <>
                                                                            {user &&
                                                                                index === 1 && (
                                                                                    <div
                                                                                        className="layout-set"
                                                                                        style={{
                                                                                            order: 1,
                                                                                        }}
                                                                                    >
                                                                                        <div className="box-crown">
                                                                                            {/* <img
                                                                                            src="../../images/ic-crown-silver.png"
                                                                                            alt=""
                                                                                        /> */}
                                                                                            <CrownCustom
                                                                                                color={
                                                                                                    findleaderboard
                                                                                                        .ranking?.[1]
                                                                                                        ?.color ||
                                                                                                    "#FFB743"
                                                                                                }
                                                                                            />
                                                                                            {/* <MainCrown color={campaign?.ranking[myData.ranking - 1]?.color} /> */}
                                                                                        </div>
                                                                                        <div className="box-head-leader">
                                                                                            <div className="img-head-leader">
                                                                                                <img
                                                                                                    src={
                                                                                                        user?.imageUrl
                                                                                                            ? user?.imageUrl
                                                                                                            : "../../images/img-profile-default-01.png"
                                                                                                    }
                                                                                                    alt=""
                                                                                                />
                                                                                            </div>
                                                                                            <div className="name">
                                                                                                {
                                                                                                    user.firstName
                                                                                                }
                                                                                            </div>
                                                                                            <div className="point">
                                                                                                {
                                                                                                    user.totalPoint
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="rank-leader">
                                                                                            {user.ranking +
                                                                                                1}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                    {findleaderboard.ranking
                                                                        .length >= 1 && (
                                                                        <>
                                                                            {user &&
                                                                                index === 0 && (
                                                                                    <div
                                                                                        className="layout-set"
                                                                                        style={{
                                                                                            order: 2,
                                                                                        }}
                                                                                    >
                                                                                        <div className="box-crown">
                                                                                            {/* <img
                                                                                            src="../../images/ic-crown-gold.png"
                                                                                            alt=""
                                                                                        /> */}
                                                                                            <CrownCustom
                                                                                                color={
                                                                                                    findleaderboard
                                                                                                        .ranking?.[0]
                                                                                                        ?.color ||
                                                                                                    "#FFB743"
                                                                                                }
                                                                                            />
                                                                                            {/* <MainCrown color={campaign?.ranking[myData.ranking - 1]?.color} /> */}
                                                                                        </div>
                                                                                        <div className="box-head-leader">
                                                                                            <div className="img-head-leader">
                                                                                                <img
                                                                                                    src={
                                                                                                        user?.imageUrl
                                                                                                            ? user?.imageUrl
                                                                                                            : "../../images/img-profile-default-01.png"
                                                                                                    }
                                                                                                    alt=""
                                                                                                />
                                                                                            </div>
                                                                                            <div className="name">
                                                                                                {
                                                                                                    user.firstName
                                                                                                }
                                                                                            </div>
                                                                                            <div className="point">
                                                                                                {
                                                                                                    user.totalPoint
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="rank-leader">
                                                                                            {user.ranking +
                                                                                                1}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                    {findleaderboard.ranking
                                                                        .length >= 3 && (
                                                                        <>
                                                                            {user &&
                                                                                index === 2 && (
                                                                                    <div
                                                                                        className="layout-set"
                                                                                        style={{
                                                                                            order: 3,
                                                                                        }}
                                                                                    >
                                                                                        <div className="box-crown">
                                                                                            {/* <img
                                                                                                    src="../../images/ic-crown-copper.png"
                                                                                                    alt=""
                                                                                                /> */}

                                                                                            <CrownCustom
                                                                                                color={
                                                                                                    findleaderboard
                                                                                                        .ranking?.[2]
                                                                                                        ?.color ||
                                                                                                    "#FFB743"
                                                                                                }
                                                                                            />
                                                                                            {/* <MainCrown color={campaign?.ranking[myData.ranking - 1]?.color} /> */}
                                                                                        </div>
                                                                                        <div className="box-head-leader">
                                                                                            <div className="img-head-leader">
                                                                                                <img
                                                                                                    src={
                                                                                                        user?.imageUrl
                                                                                                            ? user?.imageUrl
                                                                                                            : "../../images/img-profile-default-01.png"
                                                                                                    }
                                                                                                    alt=""
                                                                                                />
                                                                                            </div>
                                                                                            <div className="name">
                                                                                                {
                                                                                                    user.firstName
                                                                                                }
                                                                                            </div>
                                                                                            <div className="point">
                                                                                                {
                                                                                                    user.totalPoint
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="rank-leader">
                                                                                            {user.ranking +
                                                                                                1}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                            </Swiper>
                        </div>
                    </Skeleton>
                </div>
                <div className="layout-content-dialog">
                    <Skeleton active loading={isLoading} title={{ width: 100 }} paragraph={false}>
                        <div className="title-content">{t("page.campaign.stats")}</div>
                    </Skeleton>
                    <div className="layout-img-skeleton">
                        <Skeleton loading={isLoading} active title={true} paragraph={false}>
                            {getMyData && (
                                <div className="main-layout-box-detail">
                                    <div
                                        className="link"
                                        onClick={() => history.push(PATH_MY_STATE + "/" + id)}
                                    >
                                        {t("page.campaign.details")}
                                    </div>
                                    <div className="layout-top">
                                        <div className="img-detail">
                                            <span>
                                                <img
                                                    className="avatar"
                                                    src={
                                                        getMyData?.imageUrl
                                                            ? getMyData?.imageUrl
                                                            : "../../images/img-profile-default-01.png"
                                                    }
                                                    alt=""
                                                />
                                                {/* <div className="crown">
                                                    <img src="../../images/ic-crown.svg" alt="" />
                                                </div> */}
                                            </span>
                                        </div>
                                        <h2>{getMyData?.firstName}</h2>
                                    </div>
                                    <div className="content-details">
                                        <div className="layout-box-detail">
                                            <div className="ranking">
                                                <div className="title-detail">
                                                    {t("page.campaign.ranking")}
                                                </div>
                                                <span>
                                                    {getMyData.ranking + 1 !== 0 &&
                                                    getMyData.ranking + 1 <=
                                                        findleaderboard.numberOfRanking ? (
                                                        <CrownCustom
                                                            color={
                                                                findleaderboard.ranking[
                                                                    getMyData.ranking
                                                                ].color || "#FFB743"
                                                            }
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                    {/* <img src="../../images/ic-crown-gold.png" alt="" /> */}
                                                    {getMyData?.ranking + 1 > 0
                                                        ? getMyData?.ranking + 1
                                                        : "N/A"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="layout-box-detail">
                                            <div className="timeupload">
                                                <div className="title-detail">
                                                    {t("page.campaign.timeupload")}
                                                </div>
                                                <span>{myData?.totalActivity}</span>
                                            </div>
                                        </div>
                                        <div className="layout-box-detail">
                                            <div className="point">
                                                <div className="title-detail">
                                                    {t("page.campaign.totalpointscollected")}
                                                </div>
                                                <span>{myData?.totalPoint}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Skeleton>
                    </div>

                    {/* <div className="main-layout-box-detail">
                        <div className="link">Detail</div>
                        <div className="layout-top team">
                            <div className="img-detail team1">
                                <span>
                                    <img src="../../images/img-fitness-01.png" alt="" />
                                    <div className="crown">
                                        <img src="../../images/ic-crown.svg" alt="" />
                                    </div>
                                </span>
                            </div>
                            <div className="img-detail team2">
                                <span>
                                    <img src="../../images/img-fitness-02.png" alt="" />
                                </span>
                            </div>
                            <div className="img-detail team3">
                                <div className="set-block">
                                    <span>
                                        <img src="../../images/img-fitness-03.png" alt="" />
                                    </span>
                                    <div className="text-total-team">+12</div>
                                </div>
                            </div>
                            <h2>My Team</h2>
                        </div>
                        <div className="content-details">
                            <div className="layout-box-detail">
                                <div className="ranking">
                                    <div className="title-detail">Ranking</div>
                                    <span>1</span>
                                </div>
                            </div>
                            <div className="layout-box-detail">
                                <div className="timeupload">
                                    <div className="title-detail">Times upload</div>
                                    <span>423</span>
                                </div>
                            </div>
                            <div className="layout-box-detail">
                                <div className="point">
                                    <div className="title-detail">Total points</div>
                                    <span>33,000</span>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="layout-img-skeleton-small">
                        <Skeleton
                            active
                            loading={isLoading}
                            title={{ width: 100 }}
                            paragraph={false}
                        >
                            <div className="maim-layout-upload-activity">
                                <div className="img-upload-activity">
                                    {/* <img src="../../images/img-upload-ac.svg" alt="" /> */}
                                    <img
                                        src={
                                            campaign?.confirmationImage ||
                                            "../../images/img-upload-ac.svg"
                                        }
                                        alt=""
                                    />
                                </div>
                                <h3>{t("page.campaign.uploadactivitypoint")}</h3>
                                <StyledBtnUploadActivity
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => history.push(PATH_UPLOAD_ACTIVITY + "/" + id)}
                                >
                                    + {t("page.campaign.uploadactivity")}
                                </StyledBtnUploadActivity>
                            </div>
                        </Skeleton>
                    </div>
                </div>
                {/* <div className="btn-page">
                    <StyledMainJoin
                        className="btn-redeem"
                        themeColor={themes?.themeColor!}
                    // onClick={() => setOpenText(false)}
                    >
                        Join this event
                    </StyledMainJoin>
                </div> */}
                <ComponentMenuBar />
            </StyledPersonalFitness>
        </>
    );
};

const StyledPersonalFitness = styled.div<{ themeColor: string; campaignColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: ${(p) => p.campaignColor};
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    background-size: 100%;
    padding: 12px;

    .layout-img-skeleton {
        overflow: hidden;
        padding-bottom: 20px;
        .ant-skeleton {
            .ant-skeleton-title {
                height: 200px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }

    .layout-img-skeleton-small {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 100px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }

    .main-slide-leaderboard {
        .swiper-container {
            overflow: unset;
        }
        .swiper-pagination {
            bottom: -20px;
            .swiper-pagination-bullet {
                background-color: #fff;
                margin: 0;
                border-radius: 0;
                width: 16px;
                height: 3px;
            }
        }
        .layout-leaderboard {
            border-radius: 15px;
            min-height: 150px;
            background: ${(props) => props.color};
            /* background-color: #b7e4f2; */
            position: relative;
            /* background-image: url(../../images/bg-leader-01.png); */
            background-size: 100%;
            background-position: left top;
            display: grid;
            align-items: center;
            justify-content: center;
            padding: 12px;
            .title-leaderboard {
                color: black;
                position: absolute;
                top: -15px;
                left: 50%;
                transform: translateX(-50%);
                padding: 4px 20px;
                border-radius: 4px;
                background-color: ${(props) => props.themeColor};
                /* background-color: #e2f2f7; */
                font-size: 12px;
                font-weight: 600;
            }
            .wrapper-group-leader {
                display: grid;
                grid-template-columns: auto auto auto;
                gap: 20px;
                .layout-set {
                    display: inline-block;
                    background-color: #fff;
                    padding: 4px;
                    border-radius: 12px;
                    position: relative;
                    margin: 22px 0px;
                    width: 100%;
                    .rank-leader {
                        width: 30px;
                        height: 30px;
                        border: 5px solid rgb(255, 255, 255);
                        border-radius: 100%;
                        background-color: rgb(255, 225, 88);
                        display: flex;
                        -webkit-box-pack: center;
                        justify-content: center;
                        -webkit-box-align: center;
                        align-items: center;
                        position: absolute;
                        bottom: -23px;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 2;
                    }
                    .box-crown {
                        width: 25px;
                        height: 20px;
                        position: absolute;
                        top: -20px;
                        left: 50%;
                        transform: translateX(-50%);
                        svg {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    &:after {
                        content: "";
                        width: 100%;
                        height: 20px;
                        position: absolute;
                        bottom: -15px;
                        left: 0px;
                        background-image: url(../../images/bg-polygon.png);
                        background-size: 100%;
                        background-position: left top;
                        background-repeat: no-repeat;
                    }
                    .box-head-leader {
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                        .img-head-leader {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 5px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 100%;
                            }
                        }
                        .img-head-leader.team {
                            position: relative;
                            height: 50px;
                            .box-img {
                                position: absolute;
                                width: 35px;
                                height: 35px;
                            }
                            .box1 {
                                left: 5px;
                                top: 0;
                                z-index: 2;
                            }
                            .box2 {
                                left: -10px;
                                top: 10px;
                                z-index: 1;
                            }
                            .box3 {
                                left: 15px;
                                z-index: 0;
                                top: 10px;
                                .relative {
                                    position: relative;
                                    display: block;
                                    .text-total-team {
                                        position: absolute;
                                        width: 100%;
                                        height: 100%;
                                        background-color: rgba(0, 0, 0, 0.5);
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        top: 0;
                                        right: 0;
                                        border-radius: 100%;
                                        color: #fff;
                                        text-align: center;
                                        font-size: 10px;
                                        font-weight: 500;
                                    }
                                }
                            }
                        }
                        .name {
                            /* background-color: #a1dbea; */
                            background: ${(props) => props.color};
                            padding: 3px 12px;
                            border-radius: 36px;
                            overflow: hidden;
                            font-size: 10px;
                            line-height: 13px;
                            color: #000;
                            margin-bottom: 5px;
                        }
                        .point {
                            /* background: linear-gradient(180deg, #5ac2dc 0%, #82d0e4 100%); */
                            background: ${(props) => props.themeColor};
                            padding: 3px 12px;
                            border-radius: 36px;
                            font-size: 12px;
                            color: #fff;
                            font-weight: 600;
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }
    }
    .btn-page {
        margin: 16px 0;
        position: fixed;
        bottom: 16px;
        left: 16px;
        width: calc(100% - 32px);
    }
    .layout-content-dialog {
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #fff;
        padding: 16px 16px 100px;
        overflow: scroll;
        position: absolute;
        height: 65%;
        bottom: 0px;
        left: 0px;
        width: 100%;
        .maim-layout-upload-activity {
            border-radius: 14px;
            /* background-color: rgba(146, 97, 159, 0.12); */
            background: ${(props) => props.color};
            padding: 46px 16px 12px;
            position: relative;
            margin-top: 65px;
            .img-upload-activity {
                position: absolute;
                top: -50px;
                left: 50%;
                transform: translateX(-50%);
                width: 80px;
                height: 80px;
                border-radius: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            h3 {
                font-size: 12px;
                color: #525257;
                margin-bottom: 10px;
                text-align: center;
            }
        }
        .title-content {
            margin-bottom: 15px;
            font-weight: 600;
            color: black;
        }
        .main-layout-box-detail {
            /* background-color: #e2f2f7; */
            background: ${(props) => props.color};
            border-radius: 14px;
            padding: 20px 16px;
            position: relative;
            margin-bottom: 15px;
            .link {
                font-weight: 600;
                font-size: 12px;
                /* color: #3a8fab; */
                color: ${(props) => props.themeColor};
                cursor: pointer;
                position: absolute;
                right: 15px;
                top: 10px;
            }
            .layout-top {
                padding: 15px 0 15px 60px;
                position: relative;
                display: flex;
                align-items: center;
                .img-detail {
                    position: absolute;
                    left: 0;
                    top: 0;
                    border-radius: 100%;
                    border: 1.5px solid #ffb743;
                    width: 42px;
                    height: 42px;
                    span {
                        position: relative;
                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 100%;
                            object-fit: cover;
                        }
                        .crown {
                            position: absolute;
                            right: -11px;
                            top: -22px;
                            img {
                                width: 15px;
                                height: 15px;
                            }
                        }
                    }
                }
                .team {
                }
                .team1 {
                    left: 0;
                    top: -5px;
                    z-index: 2;
                    width: 37px;
                    height: 37px;
                }
                .team2 {
                    left: -10px;
                    top: 10px;
                    z-index: 1;
                    width: 37px;
                    height: 37px;
                }
                .team3 {
                    left: 10px;
                    top: 10px;
                    z-index: 0;
                    width: 37px;
                    height: 37px;
                    &:after {
                        content: "";
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        position: absolute;
                        top: 0;
                        left: 0;
                        border-radius: 100%;
                    }
                    .set-block {
                        position: relative;
                        .text-total-team {
                            position: absolute;
                            width: 100%;
                            text-align: center;
                            top: 50%;
                            z-index: 2;
                            color: #fff;
                            transform: translateY(-50%);
                            font-size: 10px;
                            font-weight: 500;
                        }
                    }
                }
                h2 {
                    font-size: 17px;
                    font-weight: 600;
                    color: #000;
                }
            }
            .content-details {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                gap: 10px;
                .layout-box-detail {
                    text-align: center;
                    position: relative;
                    &:after {
                        content: "";
                        width: 1px;
                        height: 90%;
                        background-color: #fff;
                        position: absolute;
                        right: -10px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    &:after:last-child {
                        display: none;
                    }
                    .title-detail {
                        margin-bottom: 5px;
                        font-size: 11px;
                        color: ${(props) => props.themeColor};
                    }
                    span {
                        padding: 10px 0;
                        display: inline-block;
                        color: black;
                        img {
                            width: 20px;
                            margin-right: 10px;
                        }
                        svg {
                            width: 20px;
                            margin-right: 10px;
                        }
                    }
                }
                .point {
                    span {
                        background-image: url(../../images/ic-coin-point.svg);
                        padding-left: 20px;
                        font-size: 14px;
                        color: rgb(0, 0, 0);
                        background-repeat: no-repeat;
                        background-position: center left;
                        background-size: 16px;
                    }
                }
                .ranking {
                    span {
                        width: 100%;
                        border-radius: 4px;
                        /* background-color: #76c0d9; */
                        background-color: ${(props) => props.themeColor};
                        padding: 10px 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 600;
                        color: #fff;
                    }
                }
            }
        }
        .top-content {
            width: 100%;
            padding: 16px 16px;
            background-color: #f3efeb;
            span {
                background-image: url(../../images/trophy.png);
                font-size: 18px;
                line-height: 21px;
                font-weight: 600;
                background-position: left center;
                background-repeat: no-repeat;
                padding-left: 30px;
            }
        }
        .main-content {
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            overflow: hidden;
            background: #fff;
            padding: 16px;
            .box-content {
                border-bottom: 1px solid #e1e1e1;
                margin: 0 0 16px;
                &:last-child {
                    border: none;
                }
            }
        }
    }
    .img-banner {
        width: 100%;
        position: relative;
        padding-top: 75%;
        z-index: 0;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: #fff;
        }
    }
    .logo-survey {
        font-size: 20px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        text-align: center;
        margin-bottom: 30px;
        padding-top: 15px;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 10px 12px;
    color: #000;
    background: #fff;
    border: 0.5px solid #e1e1e1;
    border-radius: 12px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledBtnUploadActivity = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: #fff;
    /* background-color: #92619f; */
    // background: linear-gradient(342deg, rgba(162,26,115,1) 0%, rgba(227,62,59,1) 100%);
    // border: 0.5px solid ${(p) => p.themeColor};
    background-color: ${(p) => p.themeColor};
    border: none;
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 52px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledMainJoin = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    // background: ${(p) => p.themeColor};
    background: linear-gradient(342deg, rgba(162, 26, 115, 1) 0%, rgba(227, 62, 59, 1) 100%);
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
